import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var nt = Object.defineProperty,
    at = Object.defineProperties;
var st = Object.getOwnPropertyDescriptors;
var W = Object.getOwnPropertySymbols;
var ct = Object.prototype.hasOwnProperty,
    pt = Object.prototype.propertyIsEnumerable;

var j = function j(t, e, o) {
  return e in t ? nt(t, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: o
  }) : t[e] = o;
},
    m = function m(t, e) {
  for (var o in e || (e = {})) {
    ct.call(e, o) && j(t, o, e[o]);
  }

  if (W) {
    var _iterator = _createForOfIteratorHelper(W(e)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var o = _step.value;
        pt.call(e, o) && j(t, o, e[o]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return t;
},
    f = function f(t, e) {
  return at(t, st(e));
};

import { useContext as dt } from "react";
import ft, { createContext as vt } from "react";
import { useEffect as ut, useRef as mt } from "react";
import lt from "react-fast-compare";

function C(t) {
  var e = mt(t),
      o = e.current,
      a = lt(o, t);
  return ut(function () {
    a || (e.current = t);
  }), a ? o : t;
}

var k = vt(null),
    z = function z(_ref) {
  var t = _ref.children,
      e = _ref.value;
  return ft.createElement(k.Provider, {
    value: C(e)
  }, t);
};

var ie = function ie() {
  return dt(k);
};

import { useContext as yt } from "react";

function ae() {
  return yt(k).params;
}

import { useContext as xt } from "react";
import St, { createContext as At } from "react";

var I = At(null),
    $ = function $(_ref2) {
  var t = _ref2.children,
      e = _ref2.value;
  return St.createElement(I.Provider, {
    value: C(e)
  }, t);
};

var fe = function fe() {
  return xt(I);
};

import { aggregate as qt, createCoreStore as Wt, makeEvent as F } from "@stackflow/core";
import E, { useEffect as jt, useMemo as zt } from "react";
import { id as Pt } from "@stackflow/core";

function v() {
  return Pt();
}

import { id as kt } from "@stackflow/core";

function A() {
  return kt();
}

import Q, { createContext as X } from "react";
import gt from "react";
var G,
    H = (G = gt.useDeferredValue) != null ? G : function (t) {
  return t;
};
import Ct, { useEffect as Tt, useState as Rt } from "react";
var J,
    L = (J = Ct.useSyncExternalStore) != null ? J : function (t, e) {
  var _Rt = Rt(function () {
    return e();
  }),
      _Rt2 = _slicedToArray(_Rt, 2),
      o = _Rt2[0],
      a = _Rt2[1];

  return Tt(function () {
    return t(function () {
      a(function () {
        return e();
      });
    });
  }), o;
};

var U = X(null),
    B = X(null),
    Y = function Y(_ref3) {
  var t = _ref3.coreStore,
      e = _ref3.children;
  var o = L(t.subscribe, t.actions.getStack, t.actions.getStack),
      a = H(o);
  return Q.createElement(B.Provider, {
    value: a
  }, Q.createElement(U.Provider, {
    value: t.actions
  }, e));
};

import ht from "react";

var T = function T() {
  return ht.useContext(U);
};

import wt from "react";

var R = function R() {
  return wt.useContext(B);
};

import b, { useEffect as Bt } from "react";
import w from "react";
import Et, { createContext as Ot } from "react";

var D = Ot(null),
    Z = function Z(_ref4) {
  var t = _ref4.children,
      e = _ref4.value;
  return Et.createElement(D.Provider, {
    value: e
  }, t);
};

import { useContext as It } from "react";

function h() {
  return It(D);
}

var Ut = function Ut(_ref5) {
  var t = _ref5.activities,
      e = _ref5.plugin;
  var o = R(),
      a = h();
  return e.render({
    stack: f(m({}, o), {
      render: function render(c) {
        var s = m(m({}, o), c);
        return {
          activities: s.activities.map(function (p) {
            return f(m({}, p), {
              key: p.id,
              render: function render(u) {
                var g = t[p.name],
                    y;

                if ("component" in g) {
                  var d = g.component;
                  y = w.createElement(d, {
                    params: p.params
                  });
                } else y = w.createElement(g, {
                  params: p.params
                });

                return a.forEach(function (d) {
                  var i, n;
                  y = (n = (i = d.wrapActivity) == null ? void 0 : i.call(d, {
                    activity: f(m({}, p), {
                      render: function render() {
                        return y;
                      }
                    })
                  })) != null ? n : y;
                }), w.createElement($, {
                  value: s
                }, w.createElement(z, {
                  key: p.id,
                  value: m(m({}, p), u)
                }, y));
              }
            });
          })
        };
      }
    })
  });
},
    _ = Ut;

var Dt = function Dt(_ref6) {
  var t = _ref6.activities;
  var e = R(),
      o = h(),
      a = o.filter(function (s) {
    return !!s.render;
  });
  Bt(function () {
    a.length === 0 && console.warn("Stackflow - There is no rendering plugin, so \"<Stack />\" doesn't render anything. If you want to render some UI, use \"@stackflow/plugin-renderer-basic\" or add another rendering plugin.");
  }, [a]);
  var c = b.createElement(b.Fragment, null, a.map(function (s) {
    return b.createElement(_, {
      key: s.key,
      activities: t,
      plugin: s
    });
  }));
  return o.forEach(function (s) {
    var p, u;
    c = (u = (p = s.wrapStack) == null ? void 0 : p.call(s, {
      stack: f(m({}, e), {
        render: function render() {
          return c;
        }
      })
    })) != null ? u : c;
  }), c;
},
    tt = Dt;

import bt, { useMemo as Nt } from "react";

function N(t) {
  return t ? t.animate === void 0 || t.animate == null ? {
    skipActiveState: !1
  } : {
    skipActiveState: !t.animate
  } : {
    skipActiveState: !1
  };
}

var et,
    Ft = (et = bt.useTransition) != null ? et : function () {
  return [!1, function (t) {
    return t();
  }];
};

function it() {
  var t = T(),
      _Ft = Ft(),
      _Ft2 = _slicedToArray(_Ft, 2),
      e = _Ft2[0],
      o = _Ft2[1];

  return Nt(function () {
    return {
      pending: e,
      push: function push(a, c, s) {
        var p = v();
        return t.push({
          activityId: p,
          activityName: a,
          activityParams: c,
          skipEnterActiveState: N(s).skipActiveState
        }), {
          activityId: p
        };
      },
      replace: function replace(a, c, s) {
        var u;
        var p = v();
        return t.replace({
          activityId: (u = s == null ? void 0 : s.activityId) != null ? u : v(),
          activityName: a,
          activityParams: c,
          skipEnterActiveState: N(s).skipActiveState
        }), {
          activityId: p
        };
      },
      pop: function pop(a) {
        t.pop({
          skipExitActiveState: N(a).skipActiveState
        });
      }
    };
  }, [t.push, t.replace, t.pop, e, o]);
}

import Mt, { useMemo as Kt } from "react";

var ot,
    Vt = (ot = Mt.useTransition) != null ? ot : function () {
  return [!1, function (t) {
    return t();
  }];
},
    rt = function rt() {
  var t = T(),
      _Vt = Vt(),
      _Vt2 = _slicedToArray(_Vt, 2),
      e = _Vt2[0],
      o = _Vt2[1];

  return Kt(function () {
    return {
      pending: e,
      stepPush: function stepPush(a) {
        var c = A();
        t.stepPush({
          stepId: c,
          stepParams: a
        });
      },
      stepReplace: function stepReplace(a) {
        var c = A();
        t.stepReplace({
          stepId: c,
          stepParams: a
        });
      },
      stepPop: function stepPop() {
        t.stepPop({});
      }
    };
  }, [t.stepPush, t.stepReplace, t.stepPop, e, o]);
};

function M(t) {
  return t ? t.animate === void 0 || t.animate == null ? {
    skipActiveState: !1
  } : {
    skipActiveState: !t.animate
  } : {
    skipActiveState: !1
  };
}

function Ii(t) {
  var d;

  var e = ((d = t.plugins) != null ? d : []).flat(1 / 0).map(function (i) {
    return i;
  }),
      o = e.map(function (i) {
    return i();
  }),
      a = Object.entries(t.activities).reduce(function (i, _ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
        n = _ref8[0],
        r = _ref8[1];

    return "component" in r ? f(m({}, i), _defineProperty({}, n, {
      paramsSchema: r.paramsSchema,
      component: r.component
    })) : f(m({}, i), _defineProperty({}, n, E.memo(r)));
  }, {}),
      c = function c() {
    return new Date().getTime() - t.transitionDuration;
  },
      s = function s() {
    var i = F("Initialized", {
      transitionDuration: t.transitionDuration,
      eventDate: c()
    }),
        n = Object.entries(a).map(function (_ref9) {
      var _ref10 = _slicedToArray(_ref9, 2),
          r = _ref10[0],
          l = _ref10[1];

      return F("ActivityRegistered", m({
        activityName: r,
        eventDate: c()
      }, "component" in l ? {
        activityParamsSchema: l.paramsSchema
      } : null));
    });
    return [i].concat(_toConsumableArray(n));
  },
      p = qt(s(), new Date().getTime()),
      u = {
    value: null
  };

  return typeof window != "undefined" && window.document.documentElement.style.setProperty("--stackflow-transition-duration", "".concat(t.transitionDuration, "ms")), {
    Stack: function Stack(i) {
      var n = zt(function () {
        var r = t.initialActivity ? [F("Pushed", {
          activityId: v(),
          activityName: t.initialActivity(),
          activityParams: {},
          eventDate: c(),
          skipEnterActiveState: !1
        })] : [],
            l = o.reduce(function (P, O) {
          var K, V, q;
          return (q = (V = O.overrideInitialEvents) == null ? void 0 : V.call(O, {
            initialEvents: P,
            initialContext: (K = i.initialContext) != null ? K : {}
          })) != null ? q : P;
        }, r);
        l.length > 0 && r.length > 0 && l !== r && console.warn("Stackflow -  Some plugin overrides an \"initialActivity\" option. The \"initialActivity\" option you set to \"".concat(r[0].activityName, "\" in the \"stackflow\" is ignored.")), l.length === 0 && console.warn("Stackflow -  There is no initial activity. If you want to set the initial activity, add the `initialActivity` option of the `stackflow()` function or add a plugin that sets the initial activity. (e.g. `@stackflow/plugin-history-sync`)");
        var x = Wt({
          initialEvents: [].concat(_toConsumableArray(s()), _toConsumableArray(l)),
          plugins: e
        });
        return u.value = x, x;
      }, []);
      return jt(function () {
        n.init();
      }, [n]), E.createElement(Z, {
        value: o
      }, E.createElement(Y, {
        coreStore: n
      }, E.createElement(tt, {
        activities: a
      })));
    },
    useFlow: it,
    useStepFlow: rt,
    actions: {
      dispatchEvent: function dispatchEvent(i, n) {
        var r;
        return (r = u.value) == null ? void 0 : r.actions.dispatchEvent(i, n);
      },
      getStack: function getStack() {
        var i, n;
        return (n = (i = u.value) == null ? void 0 : i.actions.getStack()) != null ? n : p;
      },
      push: function push(i, n, r) {
        var S;
        var l = v();
        return (S = u.value) == null || S.actions.push({
          activityId: l,
          activityName: i,
          activityParams: n,
          skipEnterActiveState: M(r).skipActiveState
        }), {
          activityId: l
        };
      },
      replace: function replace(i, n, r) {
        var S, x, P;
        var l = (S = r == null ? void 0 : r.activityId) != null ? S : v();
        return (P = u.value) == null || P.actions.replace({
          activityId: (x = r == null ? void 0 : r.activityId) != null ? x : v(),
          activityName: i,
          activityParams: n,
          skipEnterActiveState: M(r).skipActiveState
        }), {
          activityId: l
        };
      },
      pop: function pop(i) {
        var n;
        return (n = u.value) == null ? void 0 : n.actions.pop({
          skipExitActiveState: M(i).skipActiveState
        });
      },
      stepPush: function stepPush(i) {
        var r;
        var n = A();
        return (r = u.value) == null ? void 0 : r.actions.stepPush({
          stepId: n,
          stepParams: i
        });
      },
      stepReplace: function stepReplace(i) {
        var r;
        var n = A();
        return (r = u.value) == null ? void 0 : r.actions.stepReplace({
          stepId: n,
          stepParams: i
        });
      },
      stepPop: function stepPop() {
        var i;
        return (i = u.value) == null ? void 0 : i.actions.stepPop({});
      }
    },
    activities: a
  };
}

export { Ii as stackflow, it as useActions, ie as useActivity, ae as useActivityParams, fe as useStack, rt as useStepActions };